import { useLayoutEffect } from 'react';
import { Container } from '@pixi/react';

import { ReelContainer } from './components/reelContainer';
import { gameModuleStore } from './store/gameModuleStore';
import { GameBoard } from './components/gameBoard';

export function GameModule(props) {
  const { getPropsFromFrame } = gameModuleStore;
  useLayoutEffect(() => {
    getPropsFromFrame({ ...props });
  }, []);

  return (
    <Container>
      <GameBoard />
      <ReelContainer />
    </Container>
  );
}
